"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseActionType = void 0;
var CaseActionType;
(function (CaseActionType) {
    CaseActionType["CallbackCustomer"] = "CALLBACK_CUSTOMER";
    CaseActionType["ReviewQuestionnaire"] = "REVIEW_QUESTIONNAIRE";
    CaseActionType["UploadQuotation"] = "UPLOAD_QUOTATION";
    CaseActionType["ActivateChargingStation"] = "ACTIVATE_CHARGING_STATION";
    CaseActionType["ActivateChargeCard"] = "ACTIVATE_CHARGE_CARD";
})(CaseActionType || (exports.CaseActionType = CaseActionType = {}));
